export default function (element, data) {
    let blockToClone = element.querySelector('.gallery__block_items'); // Блок, который нужно клонировать
    let screenWidth = window.innerWidth * 2;

    function calculateTotalWidth() {
        return Array.from(element.querySelectorAll('.gallery__block_items')).reduce((totalWidth, block) => {
            return totalWidth + block.offsetWidth;
        }, 0); // Начальное значение для totalWidth установлено в 0
    }

    // Пока общая ширина всех блоков меньше удвоенной ширины экрана, продолжаем дублирование
    while (calculateTotalWidth() < screenWidth) {
        let clone = blockToClone.cloneNode(true);
        element.appendChild(clone);
    }

    // Обновляем CSS-переменную после завершения клонирования
    updateGalleryElementsCount(element);
}

// Функция для обновления CSS-переменной
function updateGalleryElementsCount(container) {
    let blocks = container.querySelectorAll('.gallery__block_items');
    
    let blockCount = 0;
    blocks.forEach(block => {
        blockCount += block.querySelectorAll('.gallery__item').length;
    });

    blockCount = blockCount / blocks.length;
    container.style.setProperty('--gallery-elements', blockCount);
}
